<template>
  <div id="app">
    <nav class="navbar">
      <router-link to="/" class="nav-link">home</router-link>
      <a href="https://www.freelancermap.de/profil/ariel-podzorski" class="nav-link">portfolio</a>
      <a href="https://medium.com/@arielpod" class="nav-link">blog</a>
      <router-link to="/contact" class="nav-link">contact</router-link>
    </nav>

    <router-view/>

    <FooterComponent />
  </div>
</template>

<script lang="ts" setup>
import FooterComponent from "@/components/FooterComponent.vue"
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Code', 'Droid Sans Mono', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
  color: #333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  padding: 2rem;
  display: flex;
  gap: 2rem;
  justify-content: center;
  background-color: transparent;
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-size: 1rem;
  font-weight: 400;
  position: relative;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  color: #00d1b2;
}
</style>
